/**
 * DE <-> EN page pairs for hreflang.
 *
 * Generated and verified by scripts/content/hreflang-map.mjs. Both directions
 * are checked before this file is written: a one-way hreflang is ignored by
 * search engines, and a wrong one is worse than none.
 *
 * Keys are German paths, values are the English counterpart. `alternatesFor`
 * resolves a path on either site to the full set, so the component does not
 * need to know which branch it is building.
 */
export const DE_BASE = 'https://www.primulamed.com'
export const EN_BASE = 'https://en.primulamed.com'

const PAIRS = {
  '/': '/',
  '/contact/': '/contact/',
  '/brands/': '/brands/',
  '/impressum/': '/impressum/',
  '/authors/': '/authors/',
  '/b/primula-dental/': '/b/primula-dental/',
  '/b/primula-derm/': '/b/primula-derm/',
  '/b/primula-hair/': '/b/primula-hair/',
  '/b/primula-medical-travel/': '/b/primula-medical-travel/',
  '/s/zahnmedizin/': '/s/dentistry/',
  '/s/haartransplantation/': '/s/hairtransplant/',
  '/s/haut-und-gesichtsbehandlungen/': '/s/skin-and-facial-treatments/',
  '/entdecken-sie-unsere-palette-an-metallfreien-keramikimplantaten-in-antalya-turkei/': '/explore-our-range-of-metal-free-zirconium-dental-implants-in-antalya-turkey/',
  '/alles-was-sie-ueber-haartransplantation-in-antalya-im-urlaub-wissen-muessen/': '/hair-transplant-in-antalya-on-holiday-everything-you-need-to-know/',
  '/zahnimplantat-in-antalya-im-urlaub-alles-was-sie-wissen-muessen/': '/dental-implant-in-antalya-on-holiday-everything-you-need-to-know/',
  '/dermatologie-in-antalya-primula-hautklinik/': '/dermatology-in-antalya-primula-skin-clinic/',
  '/was-kostet-ein-zahnimplantat-in-der-tuerkei-in-antalya/': '/how-much-does-a-dental-implant-cost-in-antalya-turkey/',
  '/lp-was-kostet-eine-haartransplantation-in-der-tuerkei-in-antalya/': '/lp-how-much-does-a-dhi-hair-transplant-cost-in-antalya-turkey/',
  '/das-primula-medical-travel-erlebnis/': '/the-primula-medical-travel-experience/',
  '/medica-haartransplantation-primula-hair-antalya/': '/medica-hairtransplant-primula-hair-antalya/',
}

const normalise = pathname => {
  if (!pathname) return null
  const withSlash = pathname.startsWith("/") ? pathname : `/${pathname}`
  return withSlash.endsWith("/") ? withSlash : `${withSlash}/`
}

const EN_TO_DE = Object.entries(PAIRS).reduce((acc, [de, en]) => {
  acc[en] = de
  return acc
}, {})

/**
 * @param {string} pathname current page path, e.g. "/contact/"
 * @returns {{de: string, en: string} | null} absolute URLs for both languages
 */
export const alternatesFor = pathname => {
  const p = normalise(pathname)
  if (!p) return null
  const de = PAIRS[p] ? p : EN_TO_DE[p]
  if (!de) return null
  const en = PAIRS[de]
  return {
    de: `${DE_BASE}${de === "/" ? "/" : de}`,
    en: `${EN_BASE}${en === "/" ? "/" : en}`
  }
}

export default PAIRS
